import { render } from "./CargarCartaModal.vue?vue&type=template&id=7fcf21fc&scoped=true"
import script from "./CargarCartaModal.vue?vue&type=script&lang=js"
export * from "./CargarCartaModal.vue?vue&type=script&lang=js"

import "./CargarCartaModal.vue?vue&type=style&index=0&id=7fcf21fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcf21fc"]])

export default __exports__